export const RootPrefix = 'models_page';
export const FiltersId = 'models_filters';
